import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DeleteAccount.css";
import "./Login.css";
import useTranslation from '../hooks/useTranslation';
import { deleteUserById } from '../components/api';

export default function DeleteAccount() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const storedId = localStorage.getItem("neuro_user_id");
    const storedName = localStorage.getItem("neuro_user_name");
    setUserId(storedId);
    setUserName(storedName);
  }, []);

  const handleDelete = async () => {
    setLoading(true);
    setMessage('');

    try {
      let intUserId = userId;
      if (isNaN(Number(userId)) && userName) {
        const base = process.env.REACT_APP_API_URL || '/api';
        const res = await fetch(`${base}/user/details?user_name=${encodeURIComponent(userName)}`);
        const data = await res.json();
        if (data && data.data && data.data.user_id) {
          intUserId = data.data.user_id;
        }
      }

      if (!intUserId) {
        setMessage('Could not identify your account. Please try again.');
        setLoading(false);
        return;
      }

      await deleteUserById(intUserId);
      localStorage.clear();
      setSuccess(true);
      setMessage('Account deleted successfully. Redirecting...');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setMessage('Failed to delete account. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!userId) {
    return (
      <div className="delete-account-page">
        <div className="delete-account-container">
          <div className="delete-account-card">
            <div className="delete-account-icon">🔒</div>
            <h1 className="delete-account-title">{t('Deactivate Account')}</h1>
            <p className="delete-account-subtitle">
              {t('You need to be logged in to delete your account.')}
            </p>
            <button
              className="delete-account-btn"
              onClick={() => navigate('/')}
            >
              {t('Go to Login')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="delete-account-page">
      <div className="delete-account-container">
        <div className="delete-account-card">
          <div className="delete-account-icon">⚠️</div>
          <h1 className="delete-account-title">{t('Deactivate Account')}</h1>
          <p className="delete-account-subtitle">
            {t('Are you sure you want to delete your account? This action cannot be undone.')}
          </p>

          <div className="delete-account-warning">
            <p>{t('The following data will be permanently deleted:')}</p>
            <ul>
              <li>{t('All session data and voice recordings')}</li>
              <li>{t('All emotion analysis results')}</li>
              <li>{t('All session notes')}</li>
              <li>{t('Your profile information')}</li>
            </ul>
          </div>

          {message && (
            <div className={`delete-account-message ${success ? 'success' : 'error'}`}>
              {message}
            </div>
          )}

          {!success && (
            <div className="delete-account-actions">
              <button
                className="delete-account-btn"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? t('Deleting...') : t('Yes, Delete My Account')}
              </button>
              <button
                className="delete-account-cancel"
                onClick={() => navigate('/')}
              >
                {t('Cancel')}
              </button>
            </div>
          )}

          <div className="delete-account-login-link">
            <button
              type="button"
              className="login-signup-link"
              onClick={() => navigate('/')}
            >
              {t('Back to Profile')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
